export const LAST_KNOWN_LOC = 'swimply-last_known_loc'
